export default "__VITE_ASSET__UdruvIE3__"